// Generated types for SimpleFunctionalDependency
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from '../../shared/types/neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from '../../shared/types/neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SimpleFunctionalDependencyReadAPI extends NeoNodeReadAPI {
  /** Type of dependency */
  dependency_type: string;
  /** What flows between actions */
  flow_description: string;
  /** Source action ID */
  source_action_id?: string | null;
  /** Target action IDs */
  target_action_ids?: string[];
  /** Bidirectional flow */
  bidirectional?: boolean;
}

export interface SimpleFunctionalDependencyWriteAPI extends NeoNodeWriteAPI {
  /** Type of dependency */
  dependency_type: string;
  /** What flows between actions */
  flow_description: string;
  /** Source action ID */
  source_action_id?: string | null;
  /** Target action IDs */
  target_action_ids?: string[];
  /** Bidirectional flow */
  bidirectional?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SimpleFunctionalDependencyReadAPISchema: z.ZodType<SimpleFunctionalDependencyReadAPI> = NeoNodeReadAPISchemaObject.extend({
  dependency_type: z.string(),
  flow_description: z.string(),
  source_action_id: z.string().nullable().optional(),
  target_action_ids: z.array(z.string()).optional(),
  bidirectional: z.boolean().optional(),
}).passthrough();

export const SimpleFunctionalDependencyWriteAPISchema: z.ZodType<SimpleFunctionalDependencyWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  dependency_type: z.string(),
  flow_description: z.string(),
  source_action_id: z.string().nullable().optional(),
  target_action_ids: z.array(z.string()).optional(),
  bidirectional: z.boolean().optional(),
}).passthrough();
